var map = {
	"./Atlanta_Hawks.png": 8221,
	"./Boston_Celtics.png": 4586,
	"./Brooklyn_Nets.png": 4566,
	"./Charlotte_Hornets.png": 7185,
	"./Chicago_Bulls.png": 7704,
	"./Cleveland_Cavaliers.png": 1158,
	"./Dallas_Mavericks.png": 2000,
	"./Denver_Nuggets.png": 7403,
	"./Detroit_Pistons.png": 9465,
	"./Golden_State_Warriors.png": 7558,
	"./Houston_Rockets.png": 8135,
	"./Indiana_Pacers.png": 6006,
	"./LA_Clippers.png": 5085,
	"./Los_Angeles_Lakers.png": 6620,
	"./Memphis_Grizzlies.png": 6400,
	"./Miami_Heat.png": 1973,
	"./Milwaukee_Bucks.png": 8318,
	"./Minnesota_Timberwolves.png": 565,
	"./NBA.png": 426,
	"./NBAOut.png": 3716,
	"./NBAOut2.png": 316,
	"./New_Orleans_Pelicans.png": 5594,
	"./New_York_Knicks.png": 3389,
	"./Oklahoma_City_Thunder.png": 1292,
	"./Orlando_Magic.png": 3136,
	"./Philadelphia_76ers.png": 4614,
	"./Phoenix_Suns.png": 7066,
	"./Portland_Trail_Blazers.png": 796,
	"./Sacramento_Kings.png": 3613,
	"./San_Antonio_Spurs.png": 1494,
	"./Toronto_Raptors.png": 4314,
	"./Utah_Jazz.png": 8411,
	"./Washington_Wizards.png": 9296,
	"./fallback.png": 7585,
	"./nba-logo-transparent.png": 9645,
	"./opaque.png": 6362
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5336;